export const TICKET_ANNOTATION_CREATED = "ticket-annotation-created";

export const emitTicketAnnotationCreated = (ticketId, message) => {
	window.dispatchEvent(
		new CustomEvent(TICKET_ANNOTATION_CREATED, {
			detail: { ticketId, message },
		})
	);
};
